import Button from '@/common/components/Button';
import Modal from '@/common/components/Modal';
import { LockOpen } from 'lucide-react';
import { useState } from 'react'

interface ModalConfirmUpdateEquipmentProps {
  setEquipmentFieldIsBlocked: (e: boolean) => void
}

export default function ModalConfirmUpdateEquipment({ setEquipmentFieldIsBlocked }: ModalConfirmUpdateEquipmentProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <Modal
      isOpen={modalIsOpen}
      setIsOpen={setModalIsOpen}
      Trigger={(
        <Button variant='neutral' className='h-[52px]' onClick={() => setModalIsOpen(true)}>
          <LockOpen />
        </Button>
      )}
      title="Você tem certeza que deseja alterar o equipamento?"
      subtitle="Caso altere, todos os objetos serão removidos"
      useCancellableFooter
      showClose={false}
      confirmButtonClassName="bg-primary-blue"
      onConfirm={() => {
        setEquipmentFieldIsBlocked(false)
        setModalIsOpen(false)
      }}
    />
  )
}